import request from "@/utils/request";
export const queryPage =
  "/icps/system/sign/goodService/clientOrderEvaluate/queryPage";
export function queryList(data) {
  return request({
    url: "/icps/system/sign/goodService/clientOrderEvaluate/queryList",
    method: "post",
    data,
  });
}
export function queryOrderEvaluate(data) {
  return request({
    url: "/icps/system/sign/goodService/clientOrderEvaluate/queryOrderEvaluate",
    method: "post",
    data,
  });
}
